import axios from "axios";

// The participant's answer to the information about their data, authorised by the invite link token
const headers = () => ({ Authorization: `Bearer ${sessionStorage.getItem("BreefAccesstoken") || ""}` });

export interface ConsentState {
  version: string;
  answer: "accepted" | "declined" | null;
  // What the employer may see for this breef beyond the default - its own choice, which the participant is told about
  insight?: { smallGroups: boolean; persons: boolean };
}

export const getConsent = async (): Promise<ConsentState> =>
  (await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/privacy/consent`, { headers: headers() })).data;

export const sendConsent = async (answer: "accepted" | "declined", version: string): Promise<ConsentState> =>
  (await axios.post(`${process.env.REACT_APP_API_BASE_URL}/v1/privacy/consent`, { answer, version }, { headers: headers() })).data;
